import { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
    Home,
    CheckSquare,
    StickyNote,
    Tv,
    Film,
    BookOpen,
    Link as LinkIcon,
    Settings,
    LogOut,
    Calendar as CalendarIcon
} from "lucide-react";

// Foto padrão (fallback caso o usuário não configure avatar)
import defaultAvatar from "../assets/marcus.jpeg";

import "./Sidebar.css";

export default function Sidebar() {
    const navigate = useNavigate();

    const [userName, setUserName] = useState(
        () => localStorage.getItem("myWorkspaceName") || "Visitante"
    );
    const [userAvatar, setUserAvatar] = useState(
        () => localStorage.getItem("myWorkspaceAvatar") || defaultAvatar
    );

    // Escuta mudanças de perfil disparadas pelo Config.jsx
    useEffect(() => {
        const handleProfileChange = () => {
            setUserName(localStorage.getItem("myWorkspaceName") || "Visitante");
            setUserAvatar(localStorage.getItem("myWorkspaceAvatar") || defaultAvatar);
        };
        window.addEventListener("workspaceProfileChanged", handleProfileChange);
        return () =>
            window.removeEventListener("workspaceProfileChanged", handleProfileChange);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("isAuth");
        localStorage.removeItem("isAuthExpiresAt");
        navigate("/");
    };

    // Helper para aplicar classe .active do NavLink
    const navClass = ({ isActive }) =>
        `nav-item ${isActive ? "active" : ""}`;

    return (
        <aside className="sidebar">

            {/* --- CABEÇALHO --- */}
            <div className="sidebar-header">
                <div className="profile-container">
                    <img
                        src={userAvatar}
                        alt={userName}
                        className="profile-photo-large"
                        onError={(e) => { e.target.src = defaultAvatar; }}
                    />
                </div>
                <h1 className="app-logo-text">ViniHub</h1>
            </div>

            {/* --- NAVEGAÇÃO --- */}
            <nav className="sidebar-nav">
                <NavLink to="/dashboard" className={navClass}>
                    <Home size={20} /> <span>Home</span>
                </NavLink>
                <NavLink to="/tarefas" className={navClass}>
                    <CheckSquare size={20} /> <span>Tarefas</span>
                </NavLink>
                <NavLink to="/agenda" className={navClass}>
                    <CalendarIcon size={20} /> <span>Agenda</span>
                </NavLink>
                <NavLink to="/anotacoes" className={navClass}>
                    <StickyNote size={20} /> <span>Anotações</span>
                </NavLink>
                <NavLink to="/series" className={navClass}>
                    <Tv size={20} /> <span>Séries</span>
                </NavLink>
                <NavLink to="/filmes" className={navClass}>
                    <Film size={20} /> <span>Filmes</span>
                </NavLink>
                <NavLink to="/biblioteca" className={navClass}>
                    <BookOpen size={20} /> <span>Biblioteca</span>
                </NavLink>
                <NavLink to="/links" className={navClass}>
                    <LinkIcon size={20} /> <span>Meus Links</span>
                </NavLink>
                <div className="nav-divider"></div>
                <NavLink to="/config" className={navClass}>
                    <Settings size={20} /> <span>Configurações</span>
                </NavLink>
            </nav>

            {/* --- RODAPÉ --- */}
            <div className="sidebar-footer">
                <div className="user-info-simple">
                    <p className="user-name">{userName}</p>
                    <span className="user-role">Admin</span>
                </div>

                <button
                    onClick={handleLogout}
                    className="logout-btn"
                    title="Sair"
                    aria-label="Sair da conta"
                >
                    <LogOut size={20} />
                </button>
            </div>

        </aside>
    );
}